import { useFaqStore } from './faq_store.js';
import { convertDataVToVue } from '../apply_vue_data_directives.js';
import { initFaqForms } from '../organism/organism_faq.js';

export class AccordionGroupPopular {
	constructor(component_id) {
		this.id = component_id;
		this.$root = document.querySelector('.js-' + this.id);
	}

	init() {}

	vue_setup(Vue) {
		if (!this.$root) return {};
		const store = useFaqStore(Vue);
		const template = convertDataVToVue(this.$root);
		const rootEl = this.$root;

		return Vue.defineComponent({
			name: this.id,
			template,
			setup() {
				return { faq: store };
			},
			mounted() {
				initFaqForms(jQuery(rootEl));
			},
		});
	}
}